<template>
    <div>
        <div class="loading-mask"></div>
        <div class="loading-spinner">
            <div class="loader-inner ball-pulse">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="loading-text">拼命加载中</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loading',
        mounted:function () {

        },
        methods:{

        },
        computed:{

        },
        watch: {

        },
        data() {
            return {

            }
        },

    }
</script>


<style scoped>
    @import "../../../static/css/loaders.css";

    .loading-mask{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10000;
        background-color: rgba(0,0,0,0.8);
        /*margin: 0;*/
        /*top: 0;*/
        /*right: 0;*/
        /*bottom: 0;*/
        /*left: 0;*/
        /*transition: opacity .3s;*/
    }
    .loading-spinner {
        top: 50%;
        margin-top: -21px;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        z-index: 100001;
    }
    .loading-spinner .loading-text {
        color: #409eff;
        margin: 3px 0;
        font-size: 14px;
    }
</style>
